<template>
  <MainLayout>
    <router-view/>
  </MainLayout>
</template>

<style lang="less">
@import "../node_modules/uikit/src/less/uikit.less";
</style>
<script setup>
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
UIkit.use(Icons);
import MainLayout from "@/layout/MainLayout.vue";
import $ from 'jquery';
import {onMounted} from "vue";
onMounted(()=>{
  $(document).scroll(function () {
    const toTop = $('.to-top');

    if ($(this).scrollTop() > 400) {
      toTop.fadeIn();
    } else {
      toTop.fadeOut();
    }
  });
})

</script>